var _templateObject;

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import { css } from '@creditas-ui/system';
export var shimmer = _ref => {
  var {
    theme: {
      shimmer
    }
  } = _ref;
  return css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  background-image: linear-gradient(\n    -90deg,\n    transparent 0%,\n    ", " 50%,\n    transparent 100%\n  );\n\n  background-size: 400% 400%;\n\n  animation: shimmer ", " ease-in-out infinite;\n\n  @keyframes shimmer {\n    from {\n      background-position: 0% 0%;\n    }\n    to {\n      background-position: -135% 0%;\n    }\n  }\n"])), shimmer('variants.light.color'), shimmer('base.time'));
};
//# sourceMappingURL=shimmer.js.map